module.exports = __webpack_public_path__ + "img/table.c67800c7.png";